export default __webpack_public_path__ + "static/img1-ec6902dd443369a25b15c805f104ac4b.jpg";